import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { meQueryKey } from "./api/auth";
import { ApiError } from "./api/client";
import { i18nReady } from "./i18n/i18n";
import { router } from "./routes";
import { theme } from "./theme";

// R-11: sdílení stavu pollingem; výchozí je obnovení při návratu do aplikace, obrazovky kontroly a přesunů
// si nastaví refetchInterval samy.
const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 5_000,
      // Chyby klienta (4xx) se neopakují, výpadky sítě a serveru jednou ano.
      retry: (failureCount, error) => !(error instanceof ApiError && error.status < 500) && failureCount < 1,
    },
  },
  // Vypršelé přihlášení (401) kdekoli → znovu ověřit uživatele; RequireAuth pak přesměruje na přihlášení.
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error instanceof ApiError && error.status === 401 && query.queryKey[0] !== meQueryKey[0])
        void queryClient.invalidateQueries({ queryKey: meQueryKey });
    },
  }),
});

await i18nReady;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="top-center" />
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </MantineProvider>
  </StrictMode>,
);
